import { useMemo } from "react"

import { ToggleButtonGroup as MuiToggleButtonGroup } from "@mui/material"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./L2RToggleButtonGroup.styled"

export const L2RToggleButtonGroup = (props) => {
    const {
        enforceValue = false,
        options,
        value,
        onChange,
        ...toggleButtonGroupProps
    } = props

    const onValueChange = (_event, newValue) => {
        if ((enforceValue && newValue) || !enforceValue) {
            onChange?.(newValue)
        }
    }

    const buttons = useMemo(() => {
        return options.map((option) => {
            return (
                <Styled.ToggleButton key={option.value} value={option.value} buttonColor={option.color || "primary"}>
                    {option.component}
                </Styled.ToggleButton>)
        })
    }, [options])

    return (
        <Styled.ToggleButtonGroup
            value={value}
            onChange={onValueChange}
            {...toggleButtonGroupProps}
        >
            {buttons}
        </Styled.ToggleButtonGroup>
    )
}

L2RToggleButtonGroup.propTypes = {
    enforceValue: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        component: PropTypes.object.isRequired,
        color: PropTypes.string,
    })).isRequired,
    color: PropTypes.string,
    ...MuiToggleButtonGroup.propTypes,
}